
export default {
  data () { return {} },
  methods: {
    async getDriverInfo () {
      try {
        let data = await this.getDriverInfoData()
        if (data) this.$store.commit('updateDriverInfo', data)
      } catch (error) {
        console.log(error)
      }
    },
    getDriverInfoData () {
      let self = this
      return new Promise((resolve, reject) => {
        self.$store.dispatch('getDriverInfo')
          .then(response => {
            if (response && response.data.result) {
              resolve(response.data.result)
            } else {
              resolve('')
            }
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
}
